import label from "@/lang/StaticLabels.js";

export default {
  routeName: null,
  token: null,
  loginCheck: false,
  checkCode: false,
  userProfile: {},

  currentUser: {},

  loginCode: {},
  loginBranch: null,

  postCheck: false,
  checkAlert: 0,
  successMessage: null,
  warningMessage: null,
  infoMessage: null,
  dangerMessage: null,

  loadingCheck: 0,
  loadingMessage: label.caption.loading,
  loadingBtn: false,

};
